<template>
  <button
    v-if="visible"
    type="button"
    class="btn btn-sm btn-outline-primary ms-2 py-0 px-2 align-middle"
    :title="title"
    :aria-label="title"
    @click.stop="openTracking"
  >
    <i class="fas fa-eye" aria-hidden="true"></i>
  </button>
</template>

<script>
import { findSourceForField } from "@/utils/findTeuAutoTrackingSources";

export default {
  name: "FindTeuTrackingViewButton",
  inject: {
    findTeuAutoTrackingContext: { default: null },
  },
  props: {
    fieldKey: {
      type: String,
      required: true,
    },
    rawValue: {
      type: [String, Number, Array, Object],
      default: null,
    },
    modelName: {
      type: String,
      default: "",
    },
  },
  computed: {
    rule() {
      const ctx = this.findTeuAutoTrackingContext;
      if (!ctx || !ctx.rule) return null;
      const mn = String(this.modelName || ctx.modelName || "").trim();
      if (!mn || String(ctx.modelName || "").toLowerCase() !== mn.toLowerCase()) {
        return null;
      }
      return ctx.rule;
    },
    sourceConfig() {
      if (!this.rule || !this.fieldKey) return null;
      return findSourceForField(this.rule, this.fieldKey);
    },
    trackingNumber() {
      const raw = this.rawValue;
      if (raw == null || raw === "") return "";
      if (Array.isArray(raw)) {
        const first = raw.find((v) => v != null && String(v).trim() !== "");
        return first != null ? String(first).trim() : "";
      }
      if (typeof raw === "object") {
        const s = raw.label || raw.name || raw.number;
        return s != null ? String(s).trim() : "";
      }
      return String(raw).trim();
    },
    trackingType() {
      return this.sourceConfig ? this.sourceConfig.trackingType : "container";
    },
    visible() {
      return !!this.sourceConfig && !!this.trackingNumber;
    },
    title() {
      return this.$t("findTeu.viewTrackingFromField");
    },
  },
  methods: {
    openTracking() {
      if (!this.trackingNumber) return;
      this.$router
        .push({
          path: "/ft/container-tracking",
          query: {
            trackingNumber: this.trackingNumber,
            trackingType: this.trackingType,
            open: "1",
          },
        })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error("[FindTeu] navigation:", err);
          }
        });
    },
  },
};
</script>
